// extracted by mini-css-extract-plugin
export default {"page-start":"MyContentsBoxLayout_page-start__sqK17","page-contents":"MyContentsBoxLayout_page-contents__E5oJ-"};